import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import MainLayout from '../../components/MainLayout';
import './AlarmAnalysis.css';

function AlarmAnalysis() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // URL 파라미터에서 정보 가져오기
  const machine = searchParams.get('machine');
  const alarmId = searchParams.get('alarmId');

  // 상태 관리
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // 향후 API 연동을 위한 준비
    const loadAlarmData = async () => {
      try {
        setLoading(true);
        // TODO: API 호출 로직 추가
        // const data = await fetchAlarmDetail(alarmId);
        setError(null);
      } catch (err) {
        console.error('알람 데이터 조회 실패:', err);
        setError('알람 데이터를 불러오는데 실패했습니다.');
      } finally {
        setLoading(false);
      }
    };

    if (alarmId) {
      loadAlarmData();
    } else {
      setLoading(false);
    }
  }, [alarmId]);

  return (
    <MainLayout>
      <div className="alarm-analysis-container">
        {/* 헤더 */}
        <div className="alarm-analysis-header">
          <div className="alarm-analysis-header-left">
            <button className="back-button" onClick={() => navigate(-1)}>
              <span className="material-symbols-outlined">arrow_back</span>
            </button>
            <div>
              <h1 className="alarm-analysis-title">알람 상세 분석</h1>
              <p className="alarm-analysis-subtitle">
                {machine && `사출기: ${machine}`}
                {machine && alarmId && ' | '}
                {alarmId && `알람 ID: ${alarmId}`}
              </p>
            </div>
          </div>
        </div>

        {/* 로딩 상태 */}
        {loading && (
          <div className="loading-container">
            <div className="loading-spinner">
              <span className="material-symbols-outlined rotating">progress_activity</span>
              <div>알람 데이터를 불러오는 중...</div>
            </div>
          </div>
        )}

        {/* 에러 상태 */}
        {error && !loading && (
          <div className="error-container">
            <div className="error-content">
              <span className="material-symbols-outlined">error</span>
              <div>
                <div className="error-title">데이터 로드 실패</div>
                <div className="error-message">{error}</div>
              </div>
            </div>
            <button className="retry-button" onClick={() => window.location.reload()}>
              다시 시도
            </button>
          </div>
        )}

        {/* 메인 콘텐츠 */}
        {!loading && !error && (
          <div className="alarm-analysis-content">
            {/* 알람 정보 카드 */}
            <div className="alarm-info-card">
              <h2 className="section-title">알람 정보</h2>
              <div className="info-grid">
                <div className="info-item">
                  <div className="info-label">알람 ID</div>
                  <div className="info-value">{alarmId || '-'}</div>
                </div>
                <div className="info-item">
                  <div className="info-label">사출기</div>
                  <div className="info-value">{machine || '-'}</div>
                </div>
                <div className="info-item">
                  <div className="info-label">발생 시간</div>
                  <div className="info-value">-</div>
                </div>
                <div className="info-item">
                  <div className="info-label">지속 시간</div>
                  <div className="info-value">-</div>
                </div>
                <div className="info-item">
                  <div className="info-label">심각도</div>
                  <div className="info-value severity-error">-</div>
                </div>
                <div className="info-item">
                  <div className="info-label">상태</div>
                  <div className="info-value">-</div>
                </div>
              </div>
            </div>

            {/* 알람 메시지 */}
            <div className="alarm-message-card">
              <h2 className="section-title">알람 메시지</h2>
              <div className="message-content">
                <p>알람 상세 정보를 표시할 API가 필요합니다.</p>
                <p className="message-note">
                  현재 페이지는 알람 ID와 사출기 정보를 URL 파라미터로 받을 수 있도록 준비되어 있습니다.
                </p>
              </div>
            </div>

            {/* 추가 분석 정보 영역 */}
            <div className="alarm-analysis-grid">
              <div className="analysis-card">
                <h2 className="section-title">원인 분석</h2>
                <div className="analysis-content">
                  <p>알람 원인 분석 정보가 여기에 표시됩니다.</p>
                </div>
              </div>

              <div className="analysis-card">
                <h2 className="section-title">권장 조치</h2>
                <div className="analysis-content">
                  <p>권장 조치 사항이 여기에 표시됩니다.</p>
                </div>
              </div>
            </div>

            {/* API 연동 안내 */}
            <div className="api-notice">
              <span className="material-symbols-outlined">info</span>
              <div>
                <strong>API 연동 필요:</strong> 알람 상세 정보를 표시하려면 백엔드 API 엔드포인트가 필요합니다.
                <br />
                예상 엔드포인트: <code>GET /api/dashboard/alarm/{'{alarmId}'}</code>
              </div>
            </div>
          </div>
        )}
      </div>
    </MainLayout>
  );
}

export default AlarmAnalysis;
